import { sync } from '@genesislcap/foundation-utils';
import { html, ref } from '@microsoft/fast-element';
import { RESURETY_REMAP_VERSION } from '../../../../utils';
import { EditThirdParty } from './edit';

export const ThirdPartyEditTemplate = html<EditThirdParty>`
  <p class="username-label">
    ${(x) =>
      x.data?.FIRST_NAME && x.data?.LAST_NAME
        ? x.data?.FIRST_NAME + ' ' + x.data?.LAST_NAME + ' (' + x.data?.USER_NAME + ')'
        : x.data?.USER_NAME}
  </p>
  <zero-segmented-control
    class="custom-segmented-control"
    orientation="horizontal"
    :value="${sync((x) => x.subscriptionTier)}"
  >
    <zero-segmented-item
      @click=${(x) => (x.subscriptionTier = RESURETY_REMAP_VERSION.LITE)}
      class="custom-segmented-item ${(x) =>
        x.subscriptionTier !== null && x.subscriptionTier === RESURETY_REMAP_VERSION.LITE
          ? 'checked'
          : ''}"
      value="${RESURETY_REMAP_VERSION.LITE}"
      :current-checked=${(x) =>
        x.subscriptionTier !== null && x.subscriptionTier === RESURETY_REMAP_VERSION.LITE}
    >
      Lite
    </zero-segmented-item>
    <zero-segmented-item
      @click=${(x) => (x.subscriptionTier = RESURETY_REMAP_VERSION.BASIC)}
      class="custom-segmented-item ${(x) =>
        x.subscriptionTier !== null && x.subscriptionTier === RESURETY_REMAP_VERSION.BASIC
          ? 'checked'
          : ''}"
      value="${RESURETY_REMAP_VERSION.BASIC}"
      :current-checked=${(x) =>
        x.subscriptionTier !== null && x.subscriptionTier === RESURETY_REMAP_VERSION.BASIC}
    >
      Basic
    </zero-segmented-item>
    <zero-segmented-item
      @click=${(x) => (x.subscriptionTier = RESURETY_REMAP_VERSION.PRO)}
      class="custom-segmented-item ${(x) =>
        x.subscriptionTier !== null && x.subscriptionTier === RESURETY_REMAP_VERSION.PRO
          ? 'checked'
          : ''}"
      value="${RESURETY_REMAP_VERSION.PRO}"
      :current-checked=${(x) =>
        x.subscriptionTier !== null && x.subscriptionTier === RESURETY_REMAP_VERSION.PRO}
    >
      Pro
    </zero-segmented-item>
  </zero-segmented-control>
  <zero-button appearance="primary" class="accept-btn" @click=${(x) => x.editThirdParty()}>
    Accept
  </zero-button>
`;
